// extracted by mini-css-extract-plugin
export default {"transactions":"style_transactions__nCTXB","title":"style_title__RXNnO"};